import React from 'react';
import aboutImage from '../gallaries/MRB_44.JPG';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">Our Story</h2>
        <div className="about-content">
          <div className="about-text">
            <p>Nengai derives from a Maasai language which translates to "A girl from God". The word itself comes from the little and ambitious girl Ashley Nengai Allan, born with developmental disabilities.</p>
            <p>The foundation came from the dream to reality of ambitious parents of Ashley, Allan and Severina. They saw the need to help children facing the same situation who are living in unfavorable environments in the Maasai communities.</p>
            <p>Our mission is to provide support, resources, and advocacy for children with autism in the Maasai community, ensuring they have the opportunities to thrive and reach their full potential.</p>
          </div>
          <div className="about-image">
                <img src={aboutImage} alt="Maasai community" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;